exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".option_item{display:-webkit-box;display:-ms-flexbox;display:flex}.option__image{max-width:100px;max-height:100px;margin-right:1em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5ea7851f","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/Assets/components/JustGivingCharities/Page.vue
// module id = 2417
// module chunks = 1